"use strict";

var _require = require('../interfaces'),
    Envelope = _require.Envelope,
    Component = _require.Component,
    PaperComponent = _require.PaperComponent,
    LargePaperComponent = _require.LargePaperComponent,
    SampleComponent = _require.SampleComponent,
    LetterpressComponent = _require.LetterpressComponent;

module.exports = {
  Envelope: Envelope,
  Component: Component,
  PaperComponent: PaperComponent,
  LargePaperComponent: LargePaperComponent,
  SampleComponent: SampleComponent,
  LetterpressComponent: LetterpressComponent
};